/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import AddRemoveJadwal from './AddRemoveJadwal'
import {getKontrakDetails, getAccesses} from '../../../api/modules/kontrak'
import axios from 'axios'
import swal from 'sweetalert'
import {getDetailSO} from '../../../api/modules/so'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import i18next from 'i18next'
import {Spinner} from 'react-bootstrap'
import Select from 'react-select'
import {getPlant2, getSloc, getIncoterm} from '../../../api/modules/getdatalist'
import CustomUseEffect from './CustomUseEffect'
import {
  getSalesAreaKontrak,
  getFilterCity,
  getCusGrup,
  getAccAss,
} from '../../../api/modules/master-data/master_2'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import {Link, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import InputGroup from 'react-bootstrap/InputGroup'
import {PopoverText} from '../../../components/Popover/Popover'
import CurrencyInput from 'react-currency-input-field'
import {useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {BadgeColorKontrak} from 'src/components/BadgeColorKontrak'
import {FieldProductSpec} from 'src/components/FieldProductSpec'

const KontrakEdit: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const {roleId} = useAppSelector(authSelector)

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)

  const {t} = useTranslation()

  const [sipNum, setSipNum] = useState<any[]>([])
  const [showNum, setShowNum] = useState<any>()
  const [detail, setDetail] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [customer, setCustomer] = useState('')
  const [customerId, setCustomerId] = useState('')
  const [perihal, setPerihal] = useState('')
  const [estimate, setEstimate] = useState<any>()
  const [estimateFrom, setEstimateFrom] = useState<any>()
  const [assignerName, setassignerName] = useState('')
  const [assignerPos, setassignerPos] = useState('')
  const [orderSubDetail, setorderSubDetail] = useState('')
  const [fixedPrice, setFixedPrice] = useState<any>()
  const [totalQuantum, setTotalQuantum] = useState<any>()
  const [quantumApprove, setQuantumApprove] = useState<any>()
  const [isUpload, setIsUpload] = useState(false)
  const [ppn, setppn] = useState(11)
  const [beforePpn, setBeforePpn] = useState<any>()
  const [btnLoading, setBtnLoading] = useState(false)
  const [fullIncoterm, setFullIncoterm] = useState<any[]>([])
  const [incoterm, setIncoterm] = useState<any>()
  const [incoterm2, setIncoterm2] = useState('')
  const [salesOrg, setSalesOrg] = useState('')
  const [distChanel, setDistChanel] = useState('')
  const [salesAreaDetail, setSalesAreaDetail] = useState('')
  const [sektorid, setsektorid] = useState(0)
  const [kontrakSub, setKontrakSub] = useState<any[]>([])
  const [accesses, setAccesses] = useState<any>()

  const [showEdit, setShowEdit] = useState(false)
  const [sloc, setSloc] = useState<any>('')
  const [fullsloc, setFullSloc] = useState<any[]>([])
  const [plant, setPlant] = useState('')
  const [listMaterial, setListMaterial] = useState<any>()
  const [listProduct, setListProduct] = useState<any>()
  const [kuantumSisa, setKuantumSisa] = useState<any>('')
  const [matgroup, setMatgroup] = useState('')
  const [matunit, setMatUnit] = useState('')
  const [slocId, setslocId] = useState<any>('')
  const [roleUser, setRoleUser] = useState('')

  useEffect(() => {
    const getDetails = async () => {
      setLoading(true)
      const res = await getKontrakDetails(
        sessionStorage.getItem('kid'),
        localStorage.getItem('credential')
      )
      const data = res.data.data

      setDetail(data)
      let totalPricee = data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['price_after_ppn'] || 0),
        0
      )
      setFixedPrice(totalPricee)
      let totalquantum = data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['fixed_price'] || 0),
        0
      )
      setTotalQuantum(totalquantum)
      // let quantumApproved = data.order_sub_details.reduce(
      //   (a: any, b: any) => a + (b['fixed_quantum'] || 0),
      //   0
      // )
      let beforePpn = data.order_sub_details.reduce(
        (a: any, b: any) => a + (b['price_before_ppn'] || 0),
        0
      )

      function ChangeFormateDate(oldDate: any) {
        return oldDate.toString().split('-').reverse().join('-')
      }

      setIncoterm(res.data.data.incoterm1_id)
      setIncoterm2(res.data.data.incoterm2_id)
      setBeforePpn(beforePpn)
      setCustomerId(res.data.data?.customer_id)
      setCustomer(res.data.data.customer.name + '.' + res.data.data.customer.title)
      // get item.id
      let item = res.data.data.order_sub_details.map((item: any) => item.id)
      setSipNum(item)
      setEstimateFrom(new Date(ChangeFormateDate(res.data.data.validity_date_from)))
      setEstimate(new Date(ChangeFormateDate(res.data.data.validity_date_to)))
      setppn(res.data.data.order_sub_details[0]?.ppn)
      setSalesOrg(res.data.data.sales_org_code)
      setDistChanel(res.data.data.sip_order?.pengajuan_order?.distribution_channel)
      setSalesAreaDetail(res.data.data?.sales_office)
      setCityData(res.data.data?.sales_group_detail?.id)
      setCustAdd(res.data.data?.customer_account_group)
      setAccAdd(res.data.data?.account_assignment_group)
      setassignerName(res.data.data?.assigner_name)
      setassignerPos(res.data.data?.assigner_position)
      setQuantumApprove(res.data.data.total_quantum)
      setsektorid(data.sector_id)
      setKontrakSub(res.data.data.order_sub_details)
      setMatUnit(data.order_sub_details?.[0]?.unit)
    }
    const getCust = async () => {
      const res = await getCusGrup()
      setCust(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAcc = async () => {
      const res = await getAccAss()
      setacc(
        res.data.data.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          }
        })
      )
    }

    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    getAcc()
    getCust()
    getDetails()
  }, [])

  const [salesArea, setSalesArea] = useState<any[]>([])

  CustomUseEffect(() => {
    const getSalesArea = async () => {
      await getSalesAreaKontrak(distChanel, salesOrg).then((res: any) => {
        setSalesArea(
          res.data.data.map((item: any) => {
            return {
              value: item.sales_office.slice(-2),
              label: item.description,
            }
          })
        )
      })
    }
    getSalesArea()
  }, [detail])

  CustomUseEffect(() => {
    const getCity = async () => {
      await getFilterCity(salesAreaDetail).then((res: any) => {
        setCityKontrak(
          res.data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.value,
            }
          })
        )
      })
    }
    getCity()
  }, [salesAreaDetail])

  const lang = i18next.language

  const editKontrak = async () => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          const payload: any = []
          kontrakSub.forEach((data: any, _index: any) => {
            payload.push({
              id: data?.id,
              plant: data?.plant,
              plant_desc: data?.plant_desc,
              sloc: data?.sloc,
              sloc_description: data?.sloc_description,
              product_type: data?.product_type,
              product_type_desc: data?.product_type_desc,
              product_name: data?.product_name,
              material_number: data?.material_number,
              unit: data?.unit,
            })
          })
          setBtnLoading(true)
          axios
            .put(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/resubmit/${detail.id}`,
              {
                sip_order_id: detail.sip_order_id,
                customer: customerId,
                sales_office: salesAreaDetail,
                sales_group: cityData,
                customer_account_group: custAdd,
                account_assignment_group: accAdd,
                perihal: detail.perihal,
                validity_date_from: estimateFrom,
                validity_date_to: estimate,
                total_quantum: quantumApprove,
                total_price: totalQuantum,
                grand_total: fixedPrice,
                assigner_name: assignerName,
                assigner_position: assignerPos,
                order_sub_details: payload,
                incoterm1: incoterm,
                incoterm2: incoterm2,
                lang: lang,
                credentials: localStorage.getItem('credential'),
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              setIsUpload(true)
              swal({
                title: `${t('Berhasil Revisi Kontrak')}`,
                icon: 'success',
              }).then(() => {
                navigate('/management/kontrak')
              })
            })
            .catch((error) => {})
            .finally(() => {
              setBtnLoading(false)
            })
        }
      })
      .catch((err) => {})
  }

  useEffect(() => {
    const getInco = async () => {
      const res = await getIncoterm()
      const data = res.data.data.data

      setFullIncoterm(
        res.data.data.map((item: any) => {
          return {
            value: item.id,
            label: item.code,
          }
        })
      )
    }

    getInco()
  }, [])

  const [salesAreaCode, setSalesAreaCode] = useState<any>()
  const [cityKontrak, setCityKontrak] = useState<any[]>([])
  const [cityData, setCityData] = useState<any>()
  const [cust, setCust] = useState<any[]>([])
  const [custAdd, setCustAdd] = useState<any>()
  const [acc, setacc] = useState<any[]>([])
  const [accAdd, setAccAdd] = useState<any>()
  const [subOrderID, setSubOrderID] = useState('')
  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [showJadwal, setShowJadwal] = useState(false)
  const [jadwalID, setJadwalID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [requestQuantum, setReqeustQuantum] = useState('')
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }

    setFixedQuantum(temp)
  }

  const ambilAttachment = async (id: any) => {
    await getFile('order-item', id, localStorage.getItem('credential')!).then((res) => {
      handleShowAttachment(res.data.data)
      setShowUpload(true)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses?.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: `${t('page edit contract')}`})}
      </PageTitle>
      <div className='card p-5'>
        <div className='card-body'>
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-2'>{t('SIP ID')}</p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    placeholder={t('SIP ID')}
                    value={detail?.sip_order_id}
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>{t('Customer Name')}</p>
                </Col>
                <Col lg={8}>
                  {detail != null ? (
                    <Form.Control type='text' value={detail.customer.name} disabled />
                  ) : (
                    <Form.Control type='text' placeholder={t('Customer Name')} disabled />
                  )}
                </Col>
              </Row>
              <Row className=''>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>{t('order-perihal')}</p>
                </Col>
                <Col lg={8}>
                  {detail != null ? (
                    <Form.Control
                      type='text'
                      value={detail.perihal == 'PO001' ? t('Pembelian') : t('Non-Penjualan')}
                      disabled
                      placeholder={t('order-perihal')}
                    />
                  ) : (
                    <Form.Control type='text' disabled placeholder={t('order-perihal')} />
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control type='text' value={detail?.customer?.customer_code} disabled />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    as='textarea'
                    value={detail?.customer?.address}
                    disabled
                    style={{height: '95px'}}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>
                    Incoterm<span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={8}>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={(e: any) => setIncoterm(e.target.value)}
                  >
                    {fullIncoterm.map((item: any) => (
                      <>
                        {incoterm == item.value ? (
                          <option value={item.value} selected>
                            {item.label}
                          </option>
                        ) : (
                          <option value={item.value}>{item.label}</option>
                        )}
                      </>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              {detail && (
                <Row className='mb-3'>
                  <Col lg={4}>
                    <p className='fs-4 mt-3'>
                      {t('Sales Office')}
                      <span className='text-danger'>*</span>
                    </p>
                  </Col>
                  <Col lg={8}>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={(e: any) => setSalesAreaDetail(e.target.value)}
                    >
                      {salesArea.map((item: any) => (
                        <>
                          {salesAreaDetail == item.value ? (
                            <option value={item.value} selected>
                              {item.label}
                            </option>
                          ) : (
                            <option value={item.value}>{item.label}</option>
                          )}
                        </>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              )}
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>
                    {t('order-tanggal-dari')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={8} className='d-flex'>
                  {/* <DatePicker
                    className='form-control'
                    selected={estimateFrom}
                    // onChange={(date: any) => setEstimateFrom(new Date(date).toDateString())}
                    dateFormat='dd/MM/yyyy'
                  /> */}
                  <img
                    alt='calendar'
                    src={toAbsoluteUrl(`/media/icons/duotune/calendar.svg`)}
                    style={{position: 'absolute', right: '5%', marginTop: '1.1%', zIndex: '77'}}
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={4}>
                  {i18next.language == 'id' ? (
                    <p className='fs-4'>
                      {t('Assigner Name')}
                      <span className='text-danger'>*</span>
                    </p>
                  ) : (
                    <p className='fs-4 mt-3'>
                      {t('Assigner Name')}
                      <span className='text-danger'>*</span>
                    </p>
                  )}
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    defaultValue={detail?.assigner_name}
                    onChange={(e: any) => setassignerName(e.target.value)}
                    placeholder={t('Assigner Name')}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>
                    Incoterm 2<span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    placeholder='Incoterm 2'
                    defaultValue={detail?.incoterm2_id}
                    onChange={(e: any) => setIncoterm2(e.target.value)}
                  />
                </Col>
              </Row>
              {salesAreaDetail && (
                <Row className='mb-3'>
                  <Col lg={4}>
                    <p className='fs-4 mt-3'>
                      {t('Sales Group')}
                      <span className='text-danger'>*</span>
                    </p>
                  </Col>
                  <Col lg={8}>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={(e: any) => setCityData(e.target.value)}
                    >
                      {cityKontrak.map((item: any) => (
                        <>
                          {cityData == item.value ? (
                            <option value={item.value} selected>
                              {item.label}
                            </option>
                          ) : (
                            <option value={item.value}>{item.label}</option>
                          )}
                        </>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              )}
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>
                    {t('order-tanggal-berakhir')}
                    <span className='text-danger'>*</span>
                  </p>
                </Col>
                <Col lg={8} className='d-flex'>
                  {/* <DatePicker
                    className='form-control'
                    selected={estimate}
                    onChange={(date: any) => setEstimate(new Date(date).toDateString())}
                    dateFormat='dd/MM/yyyy'
                  /> */}
                  <img
                    alt='calendar'
                    src={toAbsoluteUrl(`/media/icons/duotune/calendar.svg`)}
                    style={{position: 'absolute', right: '52%', marginTop: '1.1%', zIndex: '76'}}
                  />
                </Col>
              </Row>
              <Row className=''>
                <Col lg={4}>
                  {i18next.language == 'id' ? (
                    <p className='fs-4'>
                      {t('Assigner Position')}
                      <span className='text-danger'>*</span>
                    </p>
                  ) : (
                    <p className='fs-4 mt-3'>
                      {t('Assigner Position')}
                      <span className='text-danger'>*</span>
                    </p>
                  )}
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    defaultValue={detail?.assigner_position}
                    onChange={(e: any) => setassignerPos(e.target.value)}
                    placeholder={t('Assigner Position')}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          {/* <div className='mt-8' style={{width: '50%', marginBottom: '3rem'}}>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t("SIP ID")}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t("SIP ID")}
                  value={detail?.sip_order_id}
                  disabled
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t('order-pelanggan')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={t('order-pelanggan')}
                  value={detail?.customer?.title + '.' + detail?.customer?.name}
                  disabled
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t("order-perihal")}</p>
              </Col>
              <Col lg={8}>
                <Form.Control type='text' value={detail?.perihal} disabled />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t('Assigner Name')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={detail?.assigner_name ? detail?.assigner_name : 'null'}
                  onChange={(e: any) => setassignerName(e.target.value)}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('Assigner Position')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='text'
                  placeholder={detail?.assigner_position ? detail?.assigner_position : 'null'}
                  onChange={(e: any) => setassignerPos(e.target.value)}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t('order-tanggal-dari')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='date'
                  value={detail?.validity_date_from}
                  onChange={(e: any) => setEstimateFrom(e.target.value)}
                />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4 mt-2'>{t('order-tanggal-berakhir')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control
                  type='date'
                  value={detail?.validity_date_to}
                  onChange={(e: any) => setEstimate(e.target.value)}
                />
              </Col>
            </Row>
          </div> */}

          <div className='table-responsive mt-5 bdr' style={{marginBottom: '3rem'}}>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead className='border-bottom'>
                <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                  <th className='td-order-1 text-center'>{t('kontrak-item')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-aksi')}</th>
                  <th className='td-order-2 text-center'>Status</th>
                  <th className='td-order-2 text-center'>Sales Org</th>
                  <th className='td-order-2 text-center'>{t('kontrak-incoterm')} </th>
                  {sektorid != 3 && (
                    <th className='td-order-2 text-center'>{t('kontrak-wilayah')}</th>
                  )}
                  {sektorid == 1 && <th className='td-order-2 text-center'>{t('segment')}</th>}
                  <th className='td-order-2 text-center'>{t('sub-order-endUser')}</th>
                  <th className='td-order-3 text-center'>{t('Sector')} </th>
                  <th className='td-order-2 text-center'>{t('kontrak-jenis')} </th>
                  <th className='td-order-2 text-center'>{t('Product Code')} </th>
                  <th className='td-order-2 text-center'>{t('kontrak-nama')} </th>
                  <th className='td-order-2 text-center'>{t('kontrak-spek')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-kuantum')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-harga')}</th>
                  {/* <th className='td-order-2 text-center'>Status {t('Price')}</th> */}
                  {/* <th className='td-order-2 text-center'>Price</th> */}
                  <th className='td-order-2 text-center'>{t('kontrak-hargaPPN')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-ppn')}</th>
                  <th className='td-order-2 text-center'>{t('kontrak-hargaSPPN')}</th>
                  {sektorid == 2 ? (
                    <th className='td-order-2 text-center'>{t('kontrak-Gudang')} </th>
                  ) : (
                    ''
                  )}
                </tr>
              </thead>
              {detail != null ? (
                <tbody>
                  {detail?.order_sub_details?.map((detailss: any, index: number) => {
                    return (
                      <tr
                        key={detailss?.id ?? index}
                        className='d-flex jusify-content-center w-100 align-items-center'
                      >
                        <td className='td-order-1 text-center columnFlex'>{index + 1}</td>
                        <td className='td-order-2 columnFlex'>
                          <div className='d-flex' style={{gap: 2}}>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title='Detail'
                              onClick={handleShow}
                            >
                              <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <Modal
                              show={show}
                              onHide={handleClose}
                              centered
                              scrollable
                              size='xl'
                              backdrop='static'
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Detail</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                {detailss?.sector_id == 1 && (
                                  <Row>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.produsen?.name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.incoterm1?.code}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={detailss.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_type_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('Plant')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.plant_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' Ton'
                                                : parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col sm={4}>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col sm={8}>
                                          <InputGroup>
                                            <Form.Control
                                              placeholder={t('Shipping Tolerance')}
                                              size='sm'
                                              type='text'
                                              id='shipping'
                                              value={detailss?.shipping_tolerance + '%'}
                                              disabled
                                            />
                                            <InputGroup.Text>%</InputGroup.Text>
                                          </InputGroup>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss?.payment_note)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('segment')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={t(detailss.segment_name)}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              detailss.end_user_detail?.name
                                                ? detailss.end_user_detail?.name
                                                : detailss.end_user
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss.sector?.name)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {detailss?.incoterm2 == null ? (
                                            <Form.Control
                                              value={
                                                detailss?.incoterm2_id == null ||
                                                detailss?.incoterm2_id == '0'
                                                  ? ''
                                                  : detailss?.incoterm2_id
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          ) : (
                                            <Form.Control
                                              value={detailss?.incoterm2?.code}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={detailss.city?.city_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec
                                            data={detailss.product_spec}
                                            type='editor'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-2'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_price).toLocaleString(
                                                    'en',
                                                    {maximumFractionDigits: 4}
                                                  )
                                                : parseInt(detailss?.fixed_price).toLocaleString(
                                                    'id',
                                                    {maximumFractionDigits: 4}
                                                  )
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-5'>
                                        <Col sm={4}>
                                          <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                        </Col>
                                        <Col sm={8} className='d-flex justify-content-start'>
                                          <Form.Check
                                            reverse
                                            name='ppn'
                                            className='mt-4 mb-2'
                                            type='checkbox'
                                            id='ckbox-ppn'
                                            checked={detailss?.include_ppn}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.notes}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {detailss?.sector_id == 2 && (
                                  <Row>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.produsen?.name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.incoterm1?.code}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={detailss.province?.region_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.plant_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' Ton'
                                                : parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss?.payment_note)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              detailss.end_user_detail?.name
                                                ? detailss.end_user_detail?.name
                                                : detailss.end_user
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss.sector?.name)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {detailss?.incoterm2 == null ? (
                                            <Form.Control
                                              value={
                                                detailss?.incoterm2_id == null ||
                                                detailss?.incoterm2_id == '0'
                                                  ? ''
                                                  : detailss?.incoterm2_id
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          ) : (
                                            <Form.Control
                                              value={detailss?.incoterm2?.code}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            type='text'
                                            value={detailss.city?.city_name}
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_type_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec
                                            data={detailss.product_spec}
                                            type='editor'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6 mt-3'>{t('sub-order-hargaD')}/Ton</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'Rp' + i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_price).toLocaleString(
                                                    'en',
                                                    {maximumFractionDigits: 4}
                                                  )
                                                : parseInt(detailss?.fixed_price).toLocaleString(
                                                    'id',
                                                    {maximumFractionDigits: 4}
                                                  )
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.notes}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {detailss?.sector_id == 3 && (
                                  <Row>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>Sales Org</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.produsen?.name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.incoterm1?.code}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_type_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('Plant')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.plant_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'en',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' MT'
                                                : parseInt(detailss?.fixed_quantum).toLocaleString(
                                                    'id',
                                                    {
                                                      maximumFractionDigits: 4,
                                                    }
                                                  ) + ' MT'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col sm={4}>
                                          <p className='fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col sm={8}>
                                          <InputGroup>
                                            <Form.Control
                                              placeholder={t('Shipping Tolerance')}
                                              size='sm'
                                              type='text'
                                              id='shipping'
                                              value={detailss?.shipping_tolerance + '%'}
                                              disabled
                                            />
                                            <InputGroup.Text>%</InputGroup.Text>
                                          </InputGroup>
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss?.payment_note)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              detailss.end_user_detail?.name
                                                ? detailss.end_user_detail?.name
                                                : detailss.end_user
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col md='6'>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={t(detailss.sector?.name)}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          {detailss?.incoterm2 == null ? (
                                            <Form.Control
                                              value={
                                                detailss?.incoterm2_id == null ||
                                                detailss?.incoterm2_id == '0'
                                                  ? ''
                                                  : detailss?.incoterm2_id
                                              }
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          ) : (
                                            <Form.Control
                                              value={detailss?.incoterm2?.code}
                                              type='text'
                                              disabled
                                              size='sm'
                                            />
                                          )}
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss.product_name}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4} className='d-flex align-items-center'>
                                          <p className='fs-6'>{t('sub-order-spek')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <FieldProductSpec
                                            data={detailss.product_spec}
                                            type='editor'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-2'>
                                        <Col md={4}>
                                          <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={
                                              'USD' + i18next.language === 'en'
                                                ? parseInt(detailss?.fixed_price).toLocaleString(
                                                    'en',
                                                    {maximumFractionDigits: 4}
                                                  )
                                                : parseInt(detailss?.fixed_price).toLocaleString(
                                                    'id',
                                                    {maximumFractionDigits: 4}
                                                  )
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      {/* <Row className='mb-5'>
                                        <Col sm={4}>
                                          <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                        </Col>
                                        <Col sm={8} className='d-flex justify-content-start'>
                                          <Form.Check
                                            reverse
                                            name='ppn'
                                            className='mt-4 mb-2'
                                            type='checkbox'
                                            id='ckbox-ppn'
                                            checked={detailss?.include_ppn}
                                          />
                                        </Col>
                                      </Row> */}
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            value={detailss?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                      <Row className='mb-4'>
                                        <Col md={4}>
                                          <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={detailss?.notes}
                                            type='text'
                                            disabled
                                            size='sm'
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                              </Modal.Body>
                            </Modal>

                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('order-lampiran')}
                              onClick={() => {
                                setSubOrderID(detailss.id)
                                ambilAttachment(detailss.id)
                                setShowUpload(true)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>

                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Jadwal')}
                              onClick={() => {
                                setIDSector(detailss.sector_id)
                                setProvinceName(detailss.province?.region_name)
                                setCityName(detailss.city?.city_name)
                                setProductName(detailss.product_name)
                                formattingTon(detailss.fixed_quantum)
                                setReqeustQuantum(detailss.request_quantum)
                                setJadwalID(detailss.id)
                                setShowJadwal(true)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/calendar-check-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                            <Modal
                              show={showJadwal}
                              onHide={() => {
                                setShowJadwal(false)
                                setJadwalID('')
                              }}
                              centered
                              size='lg'
                              backdrop='static'
                              keyboard={false}
                              scrollable
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>
                                  {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                                  {productName} | {fixedQuantum} Ton
                                </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <AddRemoveJadwal id={jadwalID} is_amendment={'false'} />
                              </Modal.Body>
                            </Modal>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('ubah')}
                              onClick={() => {
                                setShowEdit(true)
                              }}
                            >
                              <KTSVG
                                path='/media/icons/duotune/pencil-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          </div>
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          <BadgeColorKontrak
                            text={detailss?.status_text_contract}
                            status={detailss?.status_contract}
                            role={roleUser}
                          />
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          {detailss.produsen.name}
                        </td>
                        {detailss.incoterm2 != null ? (
                          <td className='td-order-2 text-center columnFlex'>
                            <PopoverText
                              content={detailss.incoterm1.code + '-' + detailss.incoterm2.code}
                              index={index}
                              className='spec-sliceee'
                            />
                          </td>
                        ) : (
                          <>
                            {detailss.incoterm2_id == null || detailss.incoterm2_id == '0' ? (
                              <td className='td-order-2 text-center columnFlex'>
                                {detailss.incoterm1.code}
                              </td>
                            ) : (
                              <td className='td-order-2 text-center columnFlex'>
                                <PopoverText
                                  content={detailss.incoterm1.code + '-' + detailss.incoterm2_id}
                                  index={index}
                                  className='spec-sliceee'
                                />
                              </td>
                            )}
                          </>
                        )}
                        {sektorid != 3 && (
                          <td className='td-order-2 text-center columnFlex'>
                            {detailss?.province?.region_name} {detailss.city?.city_name}
                          </td>
                        )}
                        {sektorid == 1 && (
                          <td className='td-order-2 text-center columnFlex'>
                            {t(detailss.segment_name)}
                          </td>
                        )}
                        <td className='td-order-2 text-center columnFlex'>
                          {detailss?.end_user_detail?.name
                            ? detailss.end_user_detail?.name
                            : detailss.end_user}
                        </td>
                        <td className='td-order-3 text-center columnFlex'>
                          {t(detailss?.sector?.name)}
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          {detailss?.product_type_desc}
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          <p>
                            {parseInt(detailss.material_number) == 0
                              ? ''
                              : detailss.material_number?.slice(-7)}
                          </p>
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          {detailss.product_name}
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          <PopoverText
                            content={detailss.product_spec || '-'}
                            index={index}
                            className='spec-slice'
                          />
                        </td>
                        <td className='td-order-2 text-center columnFlex'>
                          {i18next.language === 'en'
                            ? detailss.fixed_quantum?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : detailss.fixed_quantum?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}{' '}
                          {detailss.sector_id === 3 ? 'MT' : 'Ton'}
                        </td>
                        {/* <td className='td-order-2 text-center columnFlex'>
                              {detailss.request_price.toLocaleString()}/1
                            </td> */}
                        <td className='td-order-2 text-center columnFlex'>
                          {(sektorid != 3 ? 'Rp' : 'USD') +
                            (i18next.language === 'en'
                              ? detailss.fixed_price?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailss.fixed_price?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) +
                            (sektorid != 3 ? '/Ton' : '/MT')}
                        </td>
                        {/* <td className='td-order-2 text-center columnFlex'>{detailss.include_ppn ? 'Include PPN' : 'Exclude PPN'}</td> */}
                        <td className='td-order-2 text-center columnFlex'>
                          {(sektorid != 3 ? 'Rp' : 'USD') +
                            (i18next.language === 'en'
                              ? detailss.price_before_ppn?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailss.price_before_ppn?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))}
                        </td>
                        <td className='td-order-2 text-center columnFlex'>{detailss.ppn}%</td>
                        <td className='td-order-2 text-center columnFlex'>
                          {(sektorid != 3 ? 'Rp' : 'USD') +
                            (i18next.language === 'en'
                              ? detailss.price_after_ppn?.toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : detailss.price_after_ppn?.toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                }))}
                        </td>

                        {/* <td className='td-order-2 text-center columnFlex'>
                              {detailss.request_quantum.toLocaleString()}
                            </td> */}
                        {detailss?.sector_id == 2 ? (
                          <td className='td-order-2 text-center columnFlex'>
                            {detailss?.plant_desc}
                          </td>
                        ) : (
                          ''
                        )}
                      </tr>
                    )
                  })}
                </tbody>
              ) : null}
            </table>
            {/* End Table Head */}
          </div>

          {detail && (
            <div style={{width: '50%'}}>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>Total {t('Quantum')}</p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    id='totalquantum'
                    type='text'
                    aria-label='Default select example'
                    placeholder={'Total ' + t('Quantum')}
                    defaultValue={
                      (i18next.language === 'en'
                        ? quantumApprove?.toLocaleString('en', {maximumFractionDigits: 4})
                        : quantumApprove?.toLocaleString('id', {maximumFractionDigits: 4})) +
                      ' ' +
                      'Ton'
                    }
                    disabled
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>Total {t('Exclude')} PPN</p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    id='totalprice'
                    type='text'
                    aria-label='Default select example'
                    placeholder={'Total ' + t('Exclude') + ' PPN'}
                    defaultValue={
                      (sektorid != 3 ? 'Rp' : 'USD') +
                      (i18next.language === 'en'
                        ? beforePpn?.toLocaleString('en', {maximumFractionDigits: 4})
                        : beforePpn?.toLocaleString('id', {maximumFractionDigits: 4}))
                    }
                    disabled
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-3'>Total {t('Include')} PPN</p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    id='total'
                    aria-label='Default select example'
                    placeholder={'Total ' + t('Include') + ' PPN'}
                    defaultValue={
                      (sektorid != 3 ? 'Rp' : 'USD') +
                      (i18next.language === 'en'
                        ? fixedPrice?.toLocaleString('en', {maximumFractionDigits: 4})
                        : fixedPrice?.toLocaleString('id', {maximumFractionDigits: 4}))
                    }
                    disabled
                  />
                </Col>
              </Row>
            </div>
          )}

          <div className='d-flex justify-content-end mt-5'>
            <Link to={'/management/kontrak'}>
              <Button className='btn btn-secondary me-2'>{t('order-kembali')}</Button>
            </Link>
            <Button className='btn btn-primary' onClick={editKontrak} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('submit')}
            </Button>
          </div>
        </div>
      </div>
      <Modal
        show={showEdit}
        onHide={() => {
          setShowEdit(false)
        }}
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('Edit')} Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('sub-order-gudang')}</Form.Label>
                <Select placeholder={t('pilih') + ' ' + t('sub-order-gudang')} />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('storage location')}</Form.Label>
                <Form.Select aria-label='Default select example' onChange={(e: any) => {}} id='sloccc'>
                  <option value=''>
                    {t('pilih')} {t('storage location')}
                  </option>
                  {fullsloc?.map((item: any) => {
                    return (
                      <>
                        {item.sloc == slocId ? (
                          <option selected value={item.sloc + '~#~' + item.sloc_description}>
                            {item.sloc + ' - ' + item.sloc_description}
                          </option>
                        ) : (
                          <option value={item.sloc + '~#~' + item.sloc_description}>
                            {item.sloc + ' - ' + item.sloc_description}
                          </option>
                        )}
                      </>
                    )
                  })}
                </Form.Select>
              </Form.Group>
              {plant && (
                <>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-jenis')}</Form.Label>
                    <Form.Select aria-label='Default select example'>
                      <option value=''>
                        {t('pilih')} {t('kontrak-jenis')}
                      </option>
                      {listMaterial?.map((item: any) => {
                        return (
                          <>
                            {item.material_group == matgroup ? (
                              <option
                                selected
                                value={item.material_group + '~#~' + item.material_group_desc}
                              >
                                {item.material_group + ' - ' + item.material_group_desc}
                              </option>
                            ) : (
                              <option value={item.material_group + '~#~' + item.material_group_desc}>
                                {item.material_group + ' - ' + item.material_group_desc}
                              </option>
                            )}
                          </>
                        )
                      })}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-produk')}</Form.Label>
                    <Select
                      key={listProduct}
                      placeholder={t('pilih') + ' ' + t('sub-order-produk')}
                      options={listProduct}
                    />
                  </Form.Group>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('sub-order-spek')}</Form.Label>
                    <Form.Control
                      aria-label='Default select example'
                      as='textarea'
                      style={{height: '40px'}}
                      key={plant}
                    />
                  </Form.Group>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{t('kontrak-harga')}</Form.Label>
                    <InputGroup>
                      <InputGroup.Text id='basic-addon1'>
                        {sektorid != 3 ? 'Rp' : 'USD'}
                      </InputGroup.Text>
                      <CurrencyInput
                        id='rp'
                        placeholder={t('kontrak-harga')}
                        className='form-control form-control-sm'
                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {}}
                        decimalsLimit={sektorid != 3 ? -1 : 2}
                      />
                    </InputGroup>
                  </Form.Group>
                  {!kuantumSisa ? (
                    <></>
                  ) : (
                    <>
                      <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>{t('quantumsisa')}</Form.Label>
                        <Form.Control
                          aria-label='Default select example'
                          defaultValue={kuantumSisa}
                          disabled
                          key={plant}
                        />
                      </Form.Group>
                    </>
                  )}
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label>{matgroup == '8105' ? t('sack') : t('Quantum')}</Form.Label>
                    <InputGroup>
                      <CurrencyInput
                        id='ton'
                        placeholder='Quantum'
                        className='form-control form-control-sm'
                        decimalSeparator={i18next.language === 'en' ? '.' : ','}
                        groupSeparator={i18next.language === 'en' ? ',' : '.'}
                        onValueChange={(value: any) => {}}
                        decimalsLimit={3}
                      />
                      <InputGroup.Text id='basic-addon1'>
                        {matgroup == '8105' ? matunit : 'Ton'}
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </>
              )}
              <div className='d-flex justify-content-end mt-5'>
                <Button>{t('Save')}</Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export {KontrakEdit}
